import React, { useState } from 'react'
import ToolBar from './ToolBar/ToolBar'
import Footer from './Footer/Footer'
import AnnotationsBar from './AnnotationsBar/AnnotationsBar'
import { CreateVizState } from './VisualizationManager'
import { Visualizations } from "../../Pages/Data/Visualize/DataReview/Visualizations"
import { useEEGCalibrationWatcher } from "../../Pages/Data/Visualize/DataReview/Calibration/hooks"
import { EventReviewProvider } from "../../Providers/EventReviewProvider"

function VisualizationArea () {
	const [enableSideBar, setEnableSidebar] = useState(false)
	useEEGCalibrationWatcher()
	
	return (
		<div style={{background: "var(--color-surface-primary)", minHeight: "100%", height: '100%', width: '100%'}}>
			<div style={{display: "flex", position: "relative", zIndex: 2, width: "100%", height: '100%'}}>
					<div id="data-review-capture-root" style={{height: "100vh", width: "100vw", display: 'flex', flexDirection: 'column', overscrollBehavior: "contain"}}>
						<ToolBar enableSidebar={enableSideBar} />

						<div style={{ flex: 1, display: 'flex', minHeight: 0 }}>
							<EventReviewProvider>
							{/* minWidth: 0 lets the visualization canvas shrink so the right-side
							    AnnotationsBar always fits on screen. Without it the canvas keeps its
							    intrinsic (min-content) width, the right-pinned AnnotationsBar overflows
							    the viewport, and its right-aligned "Load Annotations" folder button
							    gets pushed off/against the right edge into the collapse-toggle's hit
							    region — so clicks meant for the folder land on the toggle. */}
							<div style={{flex: 1, minWidth: 0}}>
								<Visualizations />
							</div>

								<AnnotationsBar enableSidebar={enableSideBar} setEnableSidebar={setEnableSidebar} />
							</EventReviewProvider>
						</div>

						<Footer />
					</div>
				</div>
			</div>
	)
}

export default VisualizationArea;
export const useLayouts = CreateVizState('layouts', [])
export const useCurrentDisplay = CreateVizState('currentDisplay', '')
export const useSelectedLayout = CreateVizState('selectedLayout', {})
export const useToolBarSettings = CreateVizState('toolbarSettings', {})
export const usePageSize = CreateVizState('pageSize', {})
